import { render, staticRenderFns } from "./PsinEditMain.vue?vue&type=template&id=df121248&scoped=true&"
import script from "./PsinEditMain.vue?vue&type=script&lang=js&"
export * from "./PsinEditMain.vue?vue&type=script&lang=js&"
import style0 from "./PsinEditMain.vue?vue&type=style&index=0&id=df121248&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df121248",
  null
  
)

export default component.exports